import { notificationStore } from './store';
import type { NotificationHandle, NotifyOptions } from './types';

/**
 * Push a notification onto the queue from anywhere (even outside React). Returns a handle whose
 * `dismissed` promise resolves with the chosen action once the toast leaves the screen. Requires a
 * mounted `NotificationProvider`.
 */
export function notify(options: NotifyOptions): NotificationHandle {
  return notificationStore.notify(options);
}

/** Dismiss every visible notification. */
export function dismissAllNotifications(): void {
  notificationStore.dismissAll();
}
